import * as msgpack from '@mta/msgpack-js-lib';

export default class PasswordCredentials {
	constructor(
			/** ?string= */ password = '',
			/** ?string= */ confirmPassword = ''
	) {
		/** @member {?string} */
		this.password = password;
		/** @member {?string} */
		this.confirmPassword = confirmPassword;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			password: os.writeString(this.password),
			confirmPassword: os.writeString(this.confirmPassword)
		};
	}

	/**
	 * @param {!object} is
	 * @param {PasswordCredentials} value
	 */
	unpack(is, value) {
		if (value.password !== undefined)
			this.password = is.readString(value.password);
		if (value.confirmPassword !== undefined)
			this.confirmPassword = is.readString(value.confirmPassword);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.pub.utils.PasswordCredentials', PasswordCredentials);
